import React from 'react';
import { getAppLanguage, languagePath, languageOptions, translateText } from '../../../../helpers/LanguageHelper';

const LanguageSelector = () => {
    const language = getAppLanguage();
    const changeLanguage = (event) => {
        const nextLanguage = event.target.value;
        if (nextLanguage === language) return;
        try { localStorage.setItem('langCode', nextLanguage); } catch { /* The URL also stores the choice. */ }
        window.location.assign(languagePath(nextLanguage, window.location.pathname, window.location.search, window.location.hash));
    };

    return (
        <div className="ukl-language-bar">
            <div className="custom-container">
                <label htmlFor="site-language"><i className="fa fa-globe" aria-hidden="true" /> {translateText('Language')}</label>
                <select id="site-language" value={language} onChange={changeLanguage}>
                    {languageOptions.map(option => <option key={option.code} value={option.code} lang={option.code}>{option.name}</option>)}
                    {language === 'ar' && <option value="ar" lang="ar">العربية</option>}
                </select>
            </div>
        </div>
    );
};

export default LanguageSelector;
